import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import WasteGeneratedTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import wasteGenIcon from "../../../../../assets/design-revamp-company/category-icons/waste_generated_icon.svg";
const WasteGeneratedContents = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="processing-sold-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={t("WASTE_GEN_TITLE")}
          subDescription={t("WASTE_GEN_DESC")}
          isNormal={true}
          number={"16.1C"}
          icon={wasteGenIcon}
        />
      </div>
      {showTable && <WasteGeneratedTable businessId={businessId} />}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default WasteGeneratedContents;
